import React from "react";
import { Image } from "react_reusable_components";
import variables from "../../themes/base/styles/variables";

const logoStyle = {
  imageStyle: {
    width: variables.logoWidth,
    height: variables.logoHeight,
  },
};

const DensoLogo = ({ style, className, ...restProps }) => {
  return (
    <Image
      rootClassName={className}
      alt="logo"
      preview={false}
      src={"/DensoLogo.svg"}
      style={{ ...logoStyle.imageStyle, ...style }}
      {...restProps}
    />
  );
};

export default DensoLogo;
